<template>
  <b-button class="btn-sidebar btn-icon-only" variant="link" @click="toggle">
    <Icon name="menu" />
  </b-button>
</template>

<script>
export default {
  name: 'ToggleSidebar',
  methods: {
    toggle() {
      this.$store.dispatch('toggleSidebar');
    }
  }
};
</script>
